import React, { useEffect } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import loadingGif from '../../../assets/images/risk-assessment/loading.gif'

export function Calculating({ onNext, key }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onNext()
    }, 1000)
    return () => clearTimeout(timer)
  }, [onNext])

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box>
        <Typography
          sx={{
            fontSize: { xs: 24, sm: 24 },
            fontWeight: 500,
            color: '#262627',
          }}
        >
          Calculating the sort of investor you are...
        </Typography>
      </Box>
      <Typography mt={2} sx={{ color: '#495057', fontSize: 18 }}>
        Please wait.
      </Typography>
      <Box mt={4} display="flex" alignItems="center" justifyContent="center">
        <Box
          component="img"
          src={loadingGif}
          alt="Loading animation"
          sx={{
            width: 150,
            height: 150,
          }}
        />
      </Box>
    </Grid>
  )
}

export default Calculating
